/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from './store'

const removeCaches = () =>
  caches.keys().then(names => {
    for (let name of names) caches.delete(name)
  })

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB',
      )
    },
    registered(registration) {
      console.log('Service worker has been registered.')
      window.INTERVAL_SW = setInterval(() => registration.update(), 60000 * 5)
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.')
      store.commit('SET_APP_NEW_CONTENT', true)
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
      removeCaches()
    },
  })
}
